import { FC } from 'react';
import { Box, Button, chakra, Flex, Image, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import AppCard from 'presentation/components/shared/card/AppCard';
import { Color } from 'presentation/theme/colorScheme';
import { ButtonVariant } from 'presentation/theme/components/button';
import AppRoute from 'router/AppRoute';
import onlineDocumentsLogo from 'assets/img/icons/online_documents_logo.svg';

const OnlineDocumentsHomeCard: FC = (props) => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  return (
    <>
      <AppCard
        minH="130px"
        p="15px"
        display="flex"
        justifyContent="space-between"
        bgImage="linear-gradient(180deg, #848484 0%, #323232 100%)"
        bgColor={Color.Primary500}
        {...props}
      >
        <Flex flexDirection="column" justifyContent="space-between">
          <Box>
            <Text mb="10px" color="white" fontSize="18px" fontWeight={700}>
              {t('homeDocCardTitle')}
            </Text>
            <Text maxW="200px" mb="24px" color="white">
              {t('homeDocCardDescription')}
            </Text>
          </Box>
          <Flex>
            <Button
              variant={ButtonVariant.Primary}
              onClick={() => navigate(AppRoute.myDocumentsPath)}
            >
              {t('moreDetails')}
            </Button>
          </Flex>
        </Flex>
        <Image src={onlineDocumentsLogo} h="138px" w="100px" />
      </AppCard>
    </>
  );
};

export default chakra(OnlineDocumentsHomeCard);
